import Vue from 'vue'

Vue.mixin({
  methods: {
    setUnit(data) {
      this.$set(this.form.entity.servingGrammages[data.index], 'unit', data.$event.unit)
      this.$set(this.form.entity.servingGrammages[data.index], 'componentServing', data.$event.id)
      this.$set(this.form.entity.servingGrammages[data.index], 'weight', data.$event.weight)
      this.form.entity.servingGrammages[data.index].weight = data.$event.weight
      this.calculateWeight()
      this.$forceUpdate()
    },
    getPortionNameById(id) {
      for (let i = 0; i < this.portions.length; i++) {
        if (this.portions[i].id === id) {
          return this.portions[i].name
        }
      }
    },
    getPortionUnitNameById(id) {
      for (let i = 0; i < this.portions.length; i++) {
        if (this.portions[i].id === id) {
          return this.portions[i].unit
        }
      }
    },
    translateType(name) {
      return Translator.trans(`serving_grammage.entity.types.${name}`)
    },
    translateUnit(name) {
      return Translator.trans(`units.${name}`)
    },
    calculateWeight() {
      if (Object.keys(this.form.entity.servingGrammages).length === 0) {
        return 0
      }

      let weights = Object.values(this.form.entity.servingGrammages).map( servingGrammage => {
        return servingGrammage.unit === 'mass' ?
          parseFloat(servingGrammage.value) :
          parseFloat(servingGrammage.value * servingGrammage.weight)
      })

      this.$set(this.form.entity, 'calculatedWeight', parseFloat(weights.reduce((sum, x) => sum + x)).toFixed(2))
    },
    setNameFromMeal(data) {
      this.form.entity.name = data.name
    },
    addNewServingGrammage(index) {
      let newServingGrammage = this.form.entity.servingGrammages[index]
      this.form.entity.servingGrammages.push(Object.assign({}, newServingGrammage))
      this.quantityServingGrammages[newServingGrammage.meal]++
      this.calculateWeight()
      this.$forceUpdate()
    },
    generateCalorificReport() {
      $('.button-report').button('loading')
      let url = Routing.generate('api_get_ppk_calorific_report', { id: this.entityId })
      $(location).attr('href', url)
      $('.button-report').button('reset')
    },
    // liczy ile razy wystąpiła wybrana porcja
    calculateQuantityCheckedMeals() {
      let quantityServingGrammages = this.quantityServingGrammages
      let mealServingGrammages = this.getServingGrammagesForMeal()
      mealServingGrammages.forEach((servingGrammage) => {
        quantityServingGrammages[servingGrammage.meal] =
            typeof quantityServingGrammages[servingGrammage.meal] !== 'undefined' ? quantityServingGrammages[servingGrammage.meal] + 1 : 1
      })
    },
    //sprawdza czy nie wybraliśmy takich samych porcji
    checkDuplicateServing() {
      let mealServingGrammages = this.getServingGrammagesForMeal()
      let servings = mealServingGrammages.map((servingGrammage) => {
        return servingGrammage.componentServing
      })

      return (new Set(servings)).size !== servings.length

    },
    getServingGrammagesForMeal() {
      return Object.values(this.form.entity.servingGrammages).filter((servingGrammage) => {
        return 'component_meal' === servingGrammage.type
      })
    },
    getPortions(updateServingGrammages) {
      this.loading++
      let url = Routing.generate('api_get_meals_portions', { id: this.form.entity.meal,
        context: 'serving' })
      this.$http.get(url).then(response => {
        this.portions = response.data
        if (updateServingGrammages) {
          for (let i = 0; i < this.portions.length; i++) {
            this.form.entity.servingGrammages.push({
              portion: this.portions[i].id,
              type: 'portion',
              unit: this.portions[i].unit,
              value: 0,
              ratio: 1,
            })
          }
        }
        this.loading--
        this.$forceUpdate()
      }, response => {
        this.loading--
        this.handleAjaxError(response)
      })
    },
    refreshPrice(id) {
      return new Promise((resolve, reject) => {
        let url = Routing.generate('api_check_serving_price', { id })
        if (this.prepareServingPackageToSend) {
          this.prepareServingPackageToSend()
        }
        let data = { data: this.form.entity }
        let icon = $('#refreshPriceLoadingIcon')
        icon.addClass('fa-spin')

        this.$http.patch(url, data).then(response => {
          $('#lowestPrice').val(response.data.lowestPrice)

          response.data.selectedServingGrammages.forEach(grammage => {
            this.form.entity.servingGrammages.find(entityGrammage => {
              return entityGrammage.id === grammage.id
            }).price = grammage.price
          })

          icon.removeClass('fa-spin')
          resolve()
        }, response => {
          icon.removeClass('fa-spin')
          this.handleAjaxError(response)
          reject()
        })
      })
    }
  }
})
